// Script para manejar la edición del precio total de órdenes
document.addEventListener('DOMContentLoaded', function() {
  const priceInputs = document.querySelectorAll('.price-input-field');
  
  priceInputs.forEach(input => {
    // Valor original para poder revertir en caso de error
    let originalValue = parseFloat(input.value) || 0;
    
    // Formatear el valor inicial y guardarlo como data attribute
    input.value = originalValue.toFixed(2);
    input.dataset.originalValue = originalValue;
    
    // Manejar eventos de entrada
    input.addEventListener('input', function() {
      // Permitir solo números y punto decimal
      this.value = this.value.replace(/[^0-9.]/g, '');
      
      // Evitar múltiples puntos decimales
      const parts = this.value.split('.');
      if (parts.length > 2) {
        this.value = parts[0] + '.' + parts.slice(1).join('');
      }
    });
    
    // Manejar pérdida de foco (cuando el usuario termina de editar)
    input.addEventListener('blur', function() {
      const newValue = parseFloat(this.value) || 0;
      const orderId = this.dataset.orderId;
      const originalValue = parseFloat(this.dataset.originalValue) || 0;
      
      // Si el valor cambió, enviarlo al servidor
      if (newValue !== originalValue) {
        updateOrderPrice(orderId, newValue, this);
      } else {
        // Restaurar formato si no cambió
        this.value = originalValue.toFixed(2);
      }
    });
    
    // Manejar Enter
    input.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        this.blur(); // Trigger el evento blur
      }
    });
    
    // Manejar Escape para cancelar
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        const originalValue = parseFloat(this.dataset.originalValue) || 0;
        this.value = originalValue.toFixed(2);
        this.blur();
      }
    });
  });
  
  function updateOrderPrice(orderId, newPrice, inputElement) {
    // Mostrar indicador de carga
    inputElement.style.backgroundColor = '#fff3cd';
    inputElement.disabled = true;
    
    // Preparar datos para enviar
    const formData = new FormData();
    formData.append('id', orderId);
    formData.append('price', newPrice);
    formData.append('_method', 'POST');
    
    // Obtener token CSRF
    const csrfToken = document.querySelector('meta[name="csrf-token"]');
    if (csrfToken) {
      formData.append('authenticity_token', csrfToken.getAttribute('content'));
    }
    
    // Enviar actualización al servidor
    fetch(`/outp`, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrfToken ? csrfToken.getAttribute('content') : ''
      },
      body: formData
    })
    .then(response => {
      return response.json().then(data => {
        if (!response.ok) {
          throw new Error(data.error || `HTTP error! status: ${response.status}`);
        }
        return data;
      });
    })
    .then(data => {
      // Verificar si es una respuesta exitosa basada en la estructura
      if (data.status === 'ok' || data.message === 'OrderUpdatedOk') {
        // Éxito: actualizar valor original y mostrar confirmación
        inputElement.style.backgroundColor = '#d1edff';
        inputElement.value = newPrice.toFixed(2);
        
        // Actualizar valor original para futuras comparaciones
        inputElement.dataset.originalValue = newPrice;
        
        // Mostrar mensaje de éxito temporal
        showSuccessMessage('Precio actualizado correctamente');
        
        // Restaurar estilo después de un momento
        setTimeout(() => {
          inputElement.style.backgroundColor = '#f8f9fa';
        }, 1500);
        
      } else {
        throw new Error(data.error || data.message || 'Error desconocido');
      }
    })
    .catch(error => {
      console.error('Error updating price:', error);
      
      // Error: revertir al valor original
      const originalValue = parseFloat(inputElement.dataset.originalValue) || 0;
      inputElement.value = originalValue.toFixed(2);
      inputElement.style.backgroundColor = '#f8d7da';
      
      // Mostrar mensaje de error
      showErrorMessage('Error al actualizar el precio: ' + error.message);
      
      // Restaurar estilo después de un momento
      setTimeout(() => {
        inputElement.style.backgroundColor = '#f8f9fa';
      }, 3000);
    })
    .finally(() => {
      // Rehabilitar el campo
      inputElement.disabled = false;
    });
  }
  
  function showSuccessMessage(message) {
    showToast(message, 'success');
  }
  
  function showErrorMessage(message) {
    showToast(message, 'error');
  }
  
  function showToast(message, type) {
    // Crear o reutilizar contenedor de toasts
    let toastContainer = document.getElementById('toast-container');
    if (!toastContainer) {
      toastContainer = document.createElement('div');
      toastContainer.id = 'toast-container';
      toastContainer.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 9999;
      `;
      document.body.appendChild(toastContainer);
    }
    
    // Crear toast
    const toast = document.createElement('div');
    const bgColor = type === 'success' ? '#d1edff' : '#f8d7da';
    const textColor = type === 'success' ? '#0c5460' : '#721c24';
    
    toast.style.cssText = `
      background-color: ${bgColor};
      color: ${textColor};
      padding: 12px 16px;
      margin-bottom: 8px;
      border-radius: 6px;
      border: 1px solid ${type === 'success' ? '#bee5eb' : '#f5c6cb'};
      box-shadow: 0 2px 8px rgba(0,0,0,0.1);
      font-weight: 500;
      animation: slideIn 0.3s ease-out;
    `;
    
    toast.textContent = message;
    toastContainer.appendChild(toast);
    
    // Eliminar toast después de 3 segundos
    setTimeout(() => {
      if (toast.parentNode) {
        toast.style.animation = 'slideOut 0.3s ease-in';
        setTimeout(() => {
          if (toast.parentNode) {
            toastContainer.removeChild(toast);
          }
        }, 300);
      }
    }, 3000);
  }
  
  // Agregar animaciones CSS para los toasts
  if (!document.getElementById('toast-animations')) {
    const style = document.createElement('style');
    style.id = 'toast-animations';
    style.textContent = `
      @keyframes slideIn {
        from { transform: translateX(100%); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
      @keyframes slideOut {
        from { transform: translateX(0); opacity: 1; }
        to { transform: translateX(100%); opacity: 0; }
      }
    `;
    document.head.appendChild(style);
  }
});
